import { BackgroundMedia, ImageFillLayerCSSVars } from '@wix/thunderbolt-becky-types'

export const getImageFillLayerCSSVars = (
	backgroundMedia: BackgroundMedia,
	containerId: string
): Partial<ImageFillLayerCSSVars> => {
	// default to fully visible opacity for cases where inner component has no image opacity and container component
	// has image opacity because we don't want the child to inherit the parent opacity css variable value
	const { opacity = 1, type } = backgroundMedia.mediaRef ?? {}
	const imageOpacity = type === 'Image' ? opacity : undefined
	const svgFilter =
		backgroundMedia.filterEffect?.effectType && `url(#${backgroundMedia.filterEffect?.effectType}-${containerId})`

	return {
		'--fill-layer-image-opacity': imageOpacity,
		'--filter-effect-svg-url': svgFilter,
	}
}
